import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate, Link } from '@reach/router';
import {
  Form, Icon, Input, Button, Checkbox, Layout, message,
} from 'antd';

import { login } from '../../actions';
import { Logo } from '../../layouts/admin';

class Login extends Component {
  componentWillReceiveProps(nextProps) {
    const { userInfo } = this.props;
    if (nextProps.userInfo && (!userInfo || userInfo.role !== nextProps.userInfo.role) && nextProps.userInfo.role !== 2) {
      message.error('Không có quyền truy cập!');
    }
  }

  handleSubmit = event => {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.login(values);
      }
    });
  }

  render() {
    const { form: { getFieldDecorator }, isLogged, userInfo } = this.props;

    if (isLogged && userInfo && userInfo.role === 2) {
      navigate('/admin/user');
    }

    return (
      <Layout style={{ minHeight: '100vh', paddingTop: '18vh' }}>
        <Layout.Content style={{ maxWidth: 500, margin: '0 auto' }}>
          <Logo style={{ marginBottom: 50 }} />
          <Form onSubmit={this.handleSubmit} className="login-form">
            <Form.Item>
              {getFieldDecorator('username', {
                rules: [{ required: true, message: 'Vui lòng điền tên tài khoản!' }],
              })(
                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Tên tài khoản" />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Vui lòng điền mật khẩu!' }],
              })(
                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Mật khẩu" />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true,
              })(
                <Checkbox>Ghi nhớ</Checkbox>
              )}
              <Link to='/admin/forget-password' className="login-form-forgot" href="">Quên mật khẩu</Link>
              <Button type="primary" htmlType="submit" className="login-form-button">
              Đăng nhập
              </Button>
            </Form.Item>
          </Form>
        </Layout.Content>
        <Layout.Footer style={{ textAlign: 'center' }}>
          Thien Ha Corp © 2018 | Developed by <a href='https://innoteq.vn' target='__blank'>Innoteq Ltd</a>
        </Layout.Footer>
      </Layout>
    );
  }
}

export default connect(state => ({
  isLogged: state.user.isLogged,
  userInfo: state.user.userInfo,
}), {
  login,
})(Form.create()(Login));
